__webpack_require__.p = "https://static-eshop-files.my.telia.lt/_next/";